module.exports = __webpack_public_path__ + "swish_logo_primary_RGB.6a805abb.svg";